import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const Layout = ({ children }) => {
  const { user, logout, isAuthenticated } = useAuth();
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isPrototypeWorkoutPage = location.pathname === '/workout';
  const showGlobalChrome = !isAuthPage && !isPrototypeWorkoutPage;

  const navItems = [
    { path: '/', label: 'Início', short: '⌂' },
    { path: '/workout', label: 'Treino', short: '◎' },
    { path: '/workouts-manage', label: 'Treinos', short: '▤' },
    { path: '/plan', label: 'Plano IA', short: '✦' },
    { path: '/history', label: 'Histórico', short: '☰' },
    { path: '/profile', label: 'Perfil', short: '☺' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-iron-bg text-iron-text flex flex-col">
      {showGlobalChrome && (
      <header className="sticky top-0 z-40 border-b border-iron-border bg-gradient-to-b from-[#0d0d10]/95 to-transparent backdrop-blur-xl">
        <div className="max-w-app mx-auto w-full px-5 pt-7 pb-4">
          <div className="flex justify-between items-start gap-3">
            <div>
              <Link to="/" className="font-display text-[2rem] leading-none tracking-[0.2em] text-cyan-300 drop-shadow-[0_0_12px_rgba(103,232,249,0.65)]">
                IRON
              </Link>
              <span className="block font-mono text-xs text-iron-muted tracking-wide mt-1">
                Gym AI
              </span>
            </div>
            {isAuthenticated && (
              <div className="text-right">
                <div className="inline-block rounded-md border border-iron-border bg-iron-surface px-3 py-1.5 font-mono text-[10px] text-iron-muted">
                  <span className="block text-[9px] uppercase tracking-wider">Sessão</span>
                  <strong className="block text-sm text-iron-accent leading-tight">
                    {user?.name?.split(' ')[0] || 'Atleta'}
                  </strong>
                </div>
              </div>
            )}
          </div>

          {isAuthenticated && (
            <nav className="hidden sm:flex flex-wrap gap-2 mt-5">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`rounded-lg border px-3 py-1.5 font-mono text-[11px] transition-colors ${
                    isActive(item.path)
                      ? 'border-iron-accent bg-iron-accent text-black font-medium'
                      : 'border-iron-border text-iron-muted hover:border-iron-accent hover:text-iron-accent'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <button
                type="button"
                onClick={logout}
                className="rounded-lg border border-iron-danger/60 px-3 py-1.5 font-mono text-[11px] text-iron-danger hover:bg-iron-danger/10"
              >
                Sair
              </button>
            </nav>
          )}

          {!isAuthenticated && (
            <div className="flex gap-2 mt-5 justify-end">
              <Link
                to="/login"
                className="btn-primary px-5 py-2 rounded-lg font-mono text-xs"
              >
                Entrar
              </Link>
              <Link to="/register" className="btn-secondary px-5 py-2 rounded-lg font-mono text-xs">
                Cadastrar
              </Link>
            </div>
          )}
        </div>
      </header>
      )}

      <main className={`flex-1 max-w-app mx-auto w-full ${showGlobalChrome ? 'px-5 py-6 pb-safe-nav sm:pb-8' : 'px-4 py-4 sm:px-5 sm:py-5'}`}>
        {children}
      </main>

      {isAuthenticated && showGlobalChrome && (
        <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-iron-border bg-iron-surface/95 backdrop-blur-md pb-[env(safe-area-inset-bottom,0px)]">
          <div className="max-w-app mx-auto flex justify-around py-2 px-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center gap-0.5 min-w-[3rem] py-1 font-mono text-[9px] uppercase tracking-wide ${
                  isActive(item.path) ? 'text-iron-accent' : 'text-iron-muted'
                }`}
              >
                <span className="text-lg leading-none">{item.short}</span>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </nav>
      )}

      {showGlobalChrome && (
      <footer className="border-t border-iron-border py-4 mt-auto hidden sm:block">
        <p className="text-center font-mono text-[10px] text-iron-muted tracking-wide">
          © {new Date().getFullYear()} Gym AI · Feedback com IA
        </p>
      </footer>
      )}
    </div>
  );
};

export default Layout;
